jQuery(function($) {

  var testimonialSlider = $('.testimonial__content__wrap')
  .flickity({
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    imagesLoaded: true,
    setGallerySize: false
  });

  testimonialSlider.on('cellSelect', function() {
    var newTab = $(this).find('.is-selected');
    testimonialSlider.find('.flickity-viewport').delay(111).animate({height: newTab.outerHeight(true)});
  });
});

